import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpClient,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
const CryptoJS = require("crypto-js");
import Base64 from "crypto-js/enc-base64";
import { environment } from "src/environments/environment";

import { User } from "../_models/index";
import { Observable, observable } from "rxjs";
import { IPAddressService } from './getIPaddress.service';

@Injectable()
export class HmacGenerationService {
  public _config = environment;
  private publicip = this._config.public_ip;

  constructor(private http: HttpClient, private ipaddress: IPAddressService) {}

  // verify() {
  //     return this.http.get('/api/verify', this.jwt()).map((response: Response) => response.json());
  // }

  hmac_gen(data) {
    
    return Observable.create(observer => {

        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/search_fuzzy/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );

    })
    

    // return d_data;
  }

  sample_hmac_gen(keys) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = keys.user_seckey;
              let user_lkey = keys.user_lkey;
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/scrapper_monitor/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = keys.user_seckey;
    // let user_lkey = keys.user_lkey;
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/search_fuzzy/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }

  scrapper_monitor_hmac_gen() {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/scrapper_monitor/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  post_delta_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "POST";
              let end_point = "/api/get_delta/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  run_scrapper_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "POST";
              let end_point = "/api/run_scrapper/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  validation_rule_hmac_gen() {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/validation_rules/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  watchlist_options_hmac_gen() {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/get_watchlist/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  watchlist_dropdown_options_hmac_gen() {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/watchlistoptions/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  developer_dropdown_options_hmac_gen() {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/developers/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  watchlist_hmac_gen() {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "GET";
              let end_point = "/api/watchlists/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  put_scrapper_monitor_hmac_gen(data, id) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "PUT";
              let end_point = "/api/scrapper_monitor/"+id;
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  put_validation_rule_hmac_gen(data, id) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "PUT";
              let end_point = "/api/validation_rules/"+id;
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  put_watchlist_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "PUT";
              let end_point = "/api/watchlists/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  put_scrapper_status_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "PUT";
              let end_point = "/api/watchlist_status/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  put_developer_status_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "PUT";
              let end_point = "/api/watchlist_assignee/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  add_validation_rule_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "POST";
              let end_point = "/api/validation_rules/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  add_watchlist_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              // my_ip = '192.168.137.4';
              let method = "POST";
              let end_point = "/api/watchlists/";
              // let timestamp = new Date().toISOString();
              let timestamp = '2019-11-25T10:55:51Z';
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  assets_hmac_gen(data) {

   return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/get_assets/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
    // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/get_assets/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }

  worksummary_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/get_work_summary/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
    // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/get_work_summary/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }

  rca_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/get_rcas/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
    // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/get_rcas/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }

  batch_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/batch_queue/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
    // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/batch_queue/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }

  face_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/facesearch/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  report_hmac_gen(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/report_pep/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    
  }

  get_by_job_id_hmac(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/batch_queue_search/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
    // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/batch_queue_search/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }

  get_all_job_hmac(data) {

    return Observable.create(observer => {
        this.ipaddress.getIpAddress().subscribe(
            res => {
              let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
              let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
              let my_ip;
      
              my_ip = res["ip"];
              let method = "POST";
              let end_point = "/api/batch_queue_search/";
              let timestamp = new Date().toISOString();
              let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;
              
              let hmac = CryptoJS.algo.HMAC.create(
                CryptoJS.algo.SHA256,
                `${user_seckey}`
              );
              hmac.update(dd);
              let hmacc = Base64.stringify(hmac.finalize());
              
              observer.next({
                h_macc: hmacc,
                u_lkey: user_lkey,
                timestamp: timestamp
              })
              observer.complete();
              
            },
            err => {
                observer.next(err)
                observer.complete();
            }
          );
    })

    // let user_seckey = JSON.parse(localStorage.getItem("user_seckey"));
    // let user_lkey = JSON.parse(localStorage.getItem("user_lkey"));
    // let my_ip = this.publicip;
    // let method = "POST";
    // let end_point = "/api/batch_queue_search/";
    // let timestamp = new Date().toISOString();
    // let dd = `${method}\n${my_ip}\n${end_point}\n${timestamp}\n${data}`;

    // let hmac = CryptoJS.algo.HMAC.create(
    //   CryptoJS.algo.SHA256,
    //   `${user_seckey}`
    // );
    // hmac.update(dd);
    // let hmacc = Base64.stringify(hmac.finalize());
    // return {
    //   h_macc: hmacc,
    //   u_lkey: user_lkey,
    //   timestamp: timestamp
    // };
  }
}
